export enum EAdminGrowthInvestmentCategoryType {
  Undefined = 0,
  OnlineAds = 1,
  PhysicalCampaign = 2,
  People = 3,
  InfluencerOrPartner = 4,
  Tooling = 5,
  Infrastructure = 6,
  Event = 7,
  Retention = 8,
  Other = 99,
}
